import { render, staticRenderFns } from "./Semester.vue?vue&type=template&id=6ac934fe&scoped=true&"
import script from "./Semester.vue?vue&type=script&lang=js&"
export * from "./Semester.vue?vue&type=script&lang=js&"
import style0 from "./Semester.vue?vue&type=style&index=0&id=6ac934fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac934fe",
  null
  
)

export default component.exports